import {h, Fragment} from "preact"
import { HistoryElement } from "@nosto/preact"
import { useEffect, useState, useRef } from "preact/hooks"
import { defaultConfig, fallbackSeachSuggestions, fallbackSearchDesigners } from "../config"

export default function History() {
    const [ recId, setRecId ] = useState(null);
    const autocompleteRef = useRef(null);
    
    useEffect(() => {
        if(autocompleteRef?.current && recId === null) {
            const mobileSearchForm = document.querySelector('.header .search-container form');
            const isMobile = mobileSearchForm.contains(autocompleteRef?.current);
            setRecId(isMobile ? "searchdropdown-nosto-1" : "searchdropdown-nosto-2");
        }
    }, [ autocompleteRef?.current ])
    
    useEffect(() => {
        if(window.nostojs && recId){
            window.nostojs(api => {
                api
                .createRecommendationRequest({ includeTagging: true })
                .setElements([ recId ])
                .load({ skipPageViews: true, skipEvents: true })
            })
        }
    }, [ recId ]);

    const closeSearch = () => {
        const closeSearchBtn = document.querySelector('[data-search-close].header__close-icon');
        if(closeSearchBtn) {
            closeSearchBtn.click();
        }
    }

    return (
        <div className="ns-autocomplete ns-empty-state-autocomplete absolute left-0 right-0 inline-block mx-auto bg-white overflow-hidden" ref={autocompleteRef}>
            <div className="ns-autocomplete-inner pb-16 lg:pb-0">

                {/* TOP SUGGESTIONS */}
                <div className="ns-keywords-section pt-5">
                    <h6 className="ns-section-header h7--medium mb-3.5">Top Suggestions</h6>
                    <ul className="list-unstyled" aria-label="Top suggestions">
                        {(window?.nostoSearch?.topSearches || fallbackSeachSuggestions).map(search => (
                            (search.url && search.url !== '')
                                ?   <li><a class="block no-underline body-2 capitalize mb-2.5" href={search.url}>{search.text}</a></li>
                                :   <SearchTerm item={search} closeSearch={closeSearch} />
                        ))}
                    </ul>
                </div>

                {/* DESIGNER */}
                <div className="ns-designer-section pt-5">
                    <h6 className="h7--medium mb-3.5">Designer</h6>
                    <ul className="list-unstyled ns-category-keywords-list" aria-label="Designer">
                        {(window?.nostoSearch?.designers || fallbackSearchDesigners).map(category => (
                            (category.url && category.url !== '')
                                ?   <li><a class="block no-underline body-2 capitalize mb-2.5" href={category.url}>{category.text}</a></li>
                                :   <SearchTerm item={category} closeSearch={closeSearch} />
                        ))}
                    </ul>
                </div>

                {/* PRODUCTS */}
                <div id={recId} className="nosto_element ns-products-section py-5"></div>
            </div>
        </div>
    )
}

function SearchTerm({ item, closeSearch }) {
    if(!item?.text) return;

    return (
        <li>
            <HistoryElement 
                query={{ query: item.text }} 
                class="cursor-pointer" 
            >
                <div
                    className="body-2 capitalize" 
                    aria-label={`View results for ${item.text}`} 
                    role="button"
                    onClick={closeSearch}
                >
                    {item.text}
                </div>
            </HistoryElement>
        </li>
    )
}